
import { UserAgent } from '../store/user-agent.model';
import { XmppMessage } from '../../user-presence/provider/xmpp-message.service';

export const USER_AGENT_MESSAGE = 'USER_AGENT_MESSAGE';
export class UserAgentMessage implements XmppMessage {
    type = USER_AGENT_MESSAGE;
    userAgent: UserAgent;
}
